import { BrowserRouter, Routes, Route } from 'react-router-dom';
import FocusGridGame from './FocusGridGame';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/play" element={<FocusGridGame />} />
      </Routes>
    </BrowserRouter>
  );
}